import { render, staticRenderFns } from "./CheckListItemDescription.vue?vue&type=template&id=4e35df20&scoped=true&"
import script from "./CheckListItemDescription.vue?vue&type=script&lang=js&"
export * from "./CheckListItemDescription.vue?vue&type=script&lang=js&"
import style0 from "./CheckListItemDescription.vue?vue&type=style&index=0&id=4e35df20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e35df20",
  null
  
)

export default component.exports